import { useMutation } from 'react-query';

function readFileAsync(file: File): Promise<string | undefined> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result?.toString());
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
}

function isNonEmptyString(value: any) {
  return value && typeof value === 'string';
}

export function useMutationCsvReadFile() {
  return useMutation(async () => {
    // Create file input dynamically
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv';
    input.multiple = false;

    return new Promise<FileData>((resolve, reject) => {
      input.onchange = async () => {
        if (input.files && input.files.length > 0) {
          try {
            const file = input.files[0];
            const content = await readFileAsync(file);
            if (!content) {
              reject(new Error('No file contents'));
            }
            const isValid = isNonEmptyString(content!);
            if (!isValid) {
              reject(new Error('Invalid file contents'));
            }
            resolve({
              name: file.name,
              content: content!
            });
          } catch (error) {
            reject(error);
          }
        } else {
          reject(new Error('No file contents'));
        }
      };
      // Simulate a click to open the file dialog
      input.click();
    });
  });
}

export interface FileData {
  name: string;
  content: string;
}
